// Dependencies
import styled from 'styled-components'

// Utils
import { MediaQueries } from 'utils/breakpoints'

// Types
import { BannerImageOrientation } from './banner.types'

type ContainerStyleProps = {
  imageOrientation?: BannerImageOrientation
}

export const Container = styled.div<ContainerStyleProps>`
  width: 100%;

  background-color: #fff;
  border-radius: 8px;

  ${MediaQueries.notebook} {
    display: flex;
    flex-direction: ${({ imageOrientation }) =>
      imageOrientation === 'left' ? 'row-reverse' : 'row'};
    align-items: flex-start;
    justify-content: space-between;
    flex: 1 0 0;
  }
`

export const TextContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  padding: 24px;

  ${MediaQueries.medium} {
    padding: 40px;
  }
`

export const Title = styled.h3`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 40px;
  color: #000;
`

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: relative;
  z-index: 1;

  ${MediaQueries.notebook} {
    align-items: center;
  }
`

export const BannerImageWrapper = styled.div`
  display: none;

  ${MediaQueries.notebook} {
    display: block;
    height: 100%;
  }
`

export const BannerImage = styled.img`
  height: 100%;
  border-radius: 8px;
`
